export const MARGIN_RIGHT = 24;
export const GRID_ITEM_CSS_IDENTIFIER = 'grid-item';
